module.exports = __webpack_public_path__ + "static/media/kelvinng.e433b005.jpg";